var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStatusHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.92119 5.17395V8.32745L5.75428 9.49433C5.54482 9.70382 5.54482 10.0434 5.75428 10.2529C5.85903 10.3576 5.99627 10.41 6.13359 10.41C6.27085 10.41 6.40814 10.3576 6.51289 10.2529L7.83688 8.9289C7.93746 8.82833 7.99397 8.69187 7.99397 8.54962V5.17395C7.99397 4.8777 7.75382 4.63756 7.45758 4.63756C7.16133 4.63756 6.92119 4.8777 6.92119 5.17395Z",
    fill: "#FC854B",
    stroke: "#FC854B",
    strokeWidth: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2505 3.94749C12.002 1.98945 9.82162 0.768417 7.45746 0.768417C5.62354 0.768417 3.8994 1.48259 2.6026 2.77934C1.30586 4.07614 0.591682 5.80028 0.591682 7.63419C0.591682 9.4681 1.30586 11.1922 2.6026 12.489C3.8994 13.7858 5.62354 14.5 7.45746 14.5C7.46199 14.5 7.46636 14.4994 7.47087 14.4993C7.47537 14.4994 7.47974 14.5 7.48428 14.5C7.67759 14.5 7.87281 14.4918 8.06457 14.4758C8.35977 14.451 8.57905 14.1917 8.55434 13.8965C8.52959 13.6013 8.2706 13.3819 7.97505 13.4068C7.81295 13.4203 7.64785 13.4272 7.48428 13.4272C7.47974 13.4272 7.47537 13.4278 7.47087 13.4279C7.46636 13.4278 7.46199 13.4272 7.45746 13.4272C4.26318 13.4272 1.66446 10.8285 1.66446 7.63419C1.66446 4.43992 4.26318 1.84119 7.45746 1.84119C9.51606 1.84119 11.4095 2.93846 12.4442 4.68405L12.4404 4.67765L13.2505 3.94749Z",
    fill: "#FC854B",
    stroke: "#FC854B",
    strokeWidth: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0969 5.11929L13.3996 5.53592C13.7381 5.57862 14.0542 5.33331 14.0969 4.99478L14.5136 1.6921C14.5563 1.35357 14.311 1.03743 13.9724 0.994727C13.6339 0.952023 13.3178 1.19734 13.2751 1.53586L12.9365 4.21929L10.2531 3.88078C9.91459 3.83808 9.59845 4.08339 9.55574 4.42192C9.51304 4.76044 9.75835 5.07658 10.0969 5.11929Z",
    fill: "#FC854B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusHistory);
export default __webpack_public_path__ + "static/media/statusHistory.9276900b25c6d02a88ede4526dc05147.svg";
export { ForwardRef as ReactComponent };